// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "order_id",
                Decco.stringToJson(v.order_id)
              ],
              [
                "comment",
                Decco.stringToJson(v.comment)
              ]
            ]);
}

export {
  t_encode ,
  
}
/* No side effect */
